export default "__VITE_ASSET__BpsoyfDl__"